import { useState, useEffect } from "react";
import "./App.css";
var axios = require("axios").default;

//https://rapidapi.com/microsoft-azure-org-microsoft-cognitive-services/api/bing-news-search1/

function App() {
  const [storyArray, setStoryArray] = useState([]);

  const options = {
    method: "GET",
    url: "https://bing-news-search1.p.rapidapi.com/news/trendingtopics",
    params: {
      textFormat: "Raw",
      safeSearch: "Off",
      count: "100"
    },
    headers: {
      "x-bingapis-sdk": "true",
      "x-rapidapi-host": "bing-news-search1.p.rapidapi.com",
      "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
    }
  };

  function callAxios() {
    axios
      .request(options)
      .then(function (response) {
        //console.log(response.data.value);
        var storyList = response.data.value;
        var filteredList = [];

        for (var i = 0; i < storyList.length; i++) {
          if ("image" in storyList[i]) {
            filteredList.push(storyList[i]);
          }
        }
        //setStoryArray(filteredList.slice(0, 10));
        setStoryArray(filteredList);

        //console.log("filtered array is", filteredArray);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  useEffect(() => {
    callAxios();
  }, []);

  return (
    <>
      <div className="container">
        <h1>Bing Trending Topics News by Image</h1>
        <ul>
          {storyArray.map((story) => (
            <li key={story.query.text}>
              <a href={story.webSearchUrl}>
                <img src={story.image.url} alt={story.name} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default App;
